export default __webpack_public_path__ + "static/media/logo-white.13ac1f7e.webp";